import script from "./PromoList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromoList.vue?vue&type=script&setup=true&lang=ts"

import "./PromoList.vue?vue&type=style&index=0&id=759a8ca0&lang=scss"

const __exports__ = script;

export default __exports__